import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, inject } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IgxButtonDirective, IgxRippleDirective } from "@infragistics/igniteui-angular";
import { IgxGridComponent } from '@infragistics/igniteui-angular/grids/grid';
import { PopoverComponent } from "@tylertech/forge";
import { ForgeFocusIndicatorModule, ForgeIconButtonModule, ForgeIconModule, ForgePopoverProxyModule, ForgeScaffoldModule, ForgeTextFieldModule, ForgeTooltipModule } from "@tylertech/forge-angular";
import { GridFilterService } from "../../../services";

@Component({
    selector: "grid-search",
    templateUrl: "./gridSearch.tmpl.html",
    imports: [
        ForgeFocusIndicatorModule,
        ForgeIconButtonModule,
        ForgeIconModule,
        ForgePopoverProxyModule,
        ForgeScaffoldModule,
        ForgeTextFieldModule,
        ForgeTooltipModule,
        FormsModule,
        IgxButtonDirective,
        IgxRippleDirective,
        ReactiveFormsModule,
    ]
})
export class GridSearchComponent
{
    private $gridFilterService = inject(GridFilterService);

    @Input() grid: IgxGridComponent;
    @Input() columns: any[];

    @Output() readonly afterSearch = new EventEmitter<void>();

    @ViewChild("searchFilter") searchFilter: ElementRef;
    @ViewChild("popover") popover: PopoverComponent;

    get hasSearchFilter(): boolean
    {
        return !!this.$gridFilterService.searchText;
    }

    get searchText(): string
    {
        return this.$gridFilterService.searchText;
    }

    set searchText(value: string)
    {
        this.$gridFilterService.searchText = value;
    }

    toggleSearchPopover($event: any): void
    {
        if ($event.detail?.newState === "open")
            this.searchFilter.nativeElement.focus();
    }

    cancel(): void
    {
        this.popover.open = false;
        this.searchText = "";
    }

    clearFilter(): void
    {
        this.searchText = "";
        this.$gridFilterService.clearFilter(this.grid);
    }

    searchKeyDown(event: KeyboardEvent): void
    {
        if (event.key !== "Enter")
            return;
        event.preventDefault();
        event.stopPropagation();
        this.applySearch();
    }

    applySearch(): void
    {
        this.$gridFilterService.searchFilter(this.$gridFilterService.searchText, this.columns, this.grid);
        this.afterSearch.emit();
        this.popover.open = false;
    }
}
